module.exports = __webpack_public_path__ + "static/img/robotvsmanual.808aeb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robotvsmanual.png
// module id = U7FW
// module chunks = 1